import React from "react";
import ScaledLogo from "./ScaledLogo";
import styles from "./materials.module.scss";

const SlackBanner = ({ event, textColor, bgColor, titleFontSize }) => (
  <div className={styles.slackBanner} style={{ "--mat-bg": bgColor, "--mat-text": textColor }}>
    <div className={styles.slackTextContainer}>
      <span className={styles.slackLabel}>Meetup #{event.eventMeetupNo}</span>
      <span className={styles.slackTitle} style={titleFontSize ? { fontSize: `${titleFontSize}px` } : undefined}>{event.eventName}</span>
    </div>
    <div className={styles.slackLogoGroup}>
      <ScaledLogo color={event.color} width={297} height={342} />
      <span className={styles.slackLogoText}>IxDA Stavanger</span>
    </div>
  </div>
);

export default SlackBanner;
